import { Component, EventEmitter, Inject, Input, OnChanges, OnInit, Optional, Output, SimpleChanges } from '@angular/core';
import { LayoutService } from '@app/core/services/layout.service';
import { TT_VIEW_NAVIGATOR, TTViewNavigator, useNavigatorFor } from '@app/modal/state-modal/state-modal.component';
import { WebPageService, WebPageSettingEditGet } from '@app/services/web-page.service';

@Component({
    selector: 'tt-webpage-setting-edit',
    templateUrl: './webpage-setting-edit.component.html',
    styleUrls: ['./webpage-setting-edit.component.css'],
    standalone: false,
})
export class WebpageSettingEditComponent implements OnInit, OnChanges {
    @Input()
    public p2WebpageSettingKeyno?: string | number;

    @Output()
    public onSave = new EventEmitter<void>();

    public page?: WebPageSettingEditGet;

    public saving = false;

    public readonly tabletSize: MediaQueryList;

    private loadVersion = 0;

    constructor(
        private webPage: WebPageService,
        layout: LayoutService,
        @Optional() @Inject(TT_VIEW_NAVIGATOR) private navigator?: TTViewNavigator,
    ) {
        this.tabletSize = layout.getMediaQueries().tablet;
        this.navigator = useNavigatorFor(navigator, this);
    }

    public async saveChanges(): Promise<void> {
        if (!this.page || this.saving) return;

        this.saving = true;

        try {
            await this.webPage.saveWebPageSetting(this.page);
            this.saving = false;

            if (this.tabletSize.matches && this.onSave.observed) {
                this.onSave.emit();
            } else {
                await this.navigator?.back();
            }
        } catch {
            // DataTask reports the error; keep the editor open for a retry.
        } finally {
            this.saving = false;
        }
    }

    public ngOnInit(): void {
        if (this.p2WebpageSettingKeyno !== undefined && this.p2WebpageSettingKeyno !== null) return;

        const keyno = this.navigator?.params['p2_webpage_setting_keyno'];
        if (typeof keyno === 'string' || typeof keyno === 'number') void this.loadPage(keyno);
    }

    public ngOnChanges(changes: SimpleChanges): void {
        if (changes['p2WebpageSettingKeyno'] && this.p2WebpageSettingKeyno !== undefined && this.p2WebpageSettingKeyno !== null) {
            void this.loadPage(this.p2WebpageSettingKeyno);
        }
    }

    private async loadPage(keyno: string | number): Promise<void> {
        if (keyno === '') return;

        const version = ++this.loadVersion;
        this.page = undefined;
        const page = await this.webPage.getWebPageSettingEdit({ p2_webpage_setting_keyno: keyno });
        if (version === this.loadVersion) this.page = page;
    }
}
